/** @format */

import { configureStore } from '@reduxjs/toolkit'
import globalDataSlice from './globalDataSlice'
import userSlice from './userSlice'
// configureStore创建一个redux数据
const store = configureStore({
  reducer: {
    globalData: globalDataSlice,
    users: userSlice
  },
  devTools: true
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
